const jsbridgeCompact = ({
  method,
  url,
  params = {},
  callback = `jsbridgeCallback${parseInt(Math.random() * 10000)}`
}) => {
  const jsbridge = window.webkit || window.vntopnews;

  if (!jsbridge) {
    return Promise.reject({});
  }

  const query = () => {
    if (window.webkit) {
      window.webkit.messageHandlers.vntopnews.postMessage({
        action: "jsbridge",
        method: {
          method,
          params,
          callback
        }
      });
    } else {
      window.vntopnews.jsbridge(
        JSON.stringify({
          method,
          params,
          callback
        })
      );
    }
  };

  return new Promise((resolve, reject) => {
    window[callback] = jsonString => {
      url && console.log(url);
      console.log(jsonString)
      const response = JSON.parse(jsonString.replace(/[\r\n]/g, "")) || {};

      // const { params } = response;

      // if (!params) {
      //   // reject(new Error(`JsBridge error: ${jsonString}`));
      // } else {
      //   resolve(params);
      // }
      resolve(response)
      setTimeout(function () {
        resolve('')
      }, 10000)
    };

    query();
  });
};

export default {
  /**
   * 登录
   *
   * | mode | 登录方式 | 空：弹出选择；facebook：facebook登录；phone：手机号登录 |
   * | callback_func | 分享后执行的js方法名，1(成功)/2(失败)/3(取消) | |
   *
   */
  login: ({ ...args }) => {
    let search = "";
    for (let arg in args) {
      search += `${arg}=${args[arg]}&`;
    }
    search = search.slice(0, search.length - 1);
    window.location.href = `vntopnewslocal://login?${search}&callback_func=JsCallback`;
    return new Promise(resolve => {
      window.JsCallback = res => {
        resolve(res);
      };
    });
  },

  /**
   * 新页面中打开WebView
   *
   * title：标题
   * url：打开的页面地址
   */
  jump: ({ direct = false, ...args }) => {
    if (direct) {
      window.location.href = args.url;
      return;
    }
    let search = "";
    for (let arg in args) {
      search += `${arg}=${args[arg]}&`;
    }
    search = search.slice(0, search.length - 1);
    window.location.href = `vntopnewslocal://webview?${search}&trusted=1`;
  },

  share: ({ url, channel }) => {
    window.location.href = `vntopnews://share_url?url=${encodeURIComponent(
      url
    )}&dest=${channel}&callback_function=JsCallback`;
    return new Promise(resolve => {
      window.JsCallback = res => {
        resolve(res);
      };
    });
  },

  rewardPupop: ({ reward_text, from = "h5", style = "" }) => {
    window.location.href = `vntopnewslocal://reward_pupop_window?reward_text=${reward_text}&style=${style}&from=${from}`;
  },

  toast: args => jsbridgeCompact({ method: "toast", ...args }),
  openRewardAdvert: args => jsbridgeCompact({ method: "openRewardAdvert", ...args }),
  rewardedVideo2: args => jsbridgeCompact({ method: "rewardedVideo2", ...args }),
  rewardedVideo: args => jsbridgeCompact({ method: "rewardedVideo", ...args }),
  getAppsInstalled: args => jsbridgeCompact({ method: "getAppsInstalled", ...args }),
  loadInterstitial: args => jsbridgeCompact({ method: "loadInterstitial", ...args }),
  showInterstitial: args => jsbridgeCompact({ method: "showInterstitial", ...args }),
  pageConfig: args => jsbridgeCompact({ method: "pageConfig", ...args }),
  userInfo: args => jsbridgeCompact({ method: 'userInfo', ...args }),
  environment: args => jsbridgeCompact({ method: 'environment', ...args }),
  getPhoneInfo: args => jsbridgeCompact({ method: "getPhoneInfo", ...args }),
  executeUSSD: args => jsbridgeCompact({ method: 'executeUSSD', ...args }),
  openWebSocket: args => jsbridgeCompact({ method: 'openWebSocket', ...args }),
  changeUserAgent: args => jsbridgeCompact({ method: 'changeUserAgent', ...args }),
  getUserAgent: args => jsbridgeCompact({ method: 'getUserAgent', ...args }),
};
